import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    formatterTime
} from '@/util/util'



export const financialOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    printBtn: true,
    excelBtn: true,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    //入账时间排序
    // defaultSort: {
    //     prop: 'enterTime',
    //     order: 'descending'
    // },
    column: [{
            label: "业务编号",
            prop: "professionNumber",
            search: true,
            type: 'input'
        },
        {
            label: "入账来源",
            prop: "source",
            type: "select",
            search: true,
            width: "110",
            dicData: DIC.FINANCIAL_SOURCE
        },
        {
            label: "入账时间",
            prop: "enterTime",
            width: "110",
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            type: 'datetime',
            // search: true,
        },
        {
            label: "入账金额(元)",
            prop: "enterMoney",
            type: "input",
            // search: true
        },
        {
            label: "资金类型",
            prop: "type",
            type: "select",
            search: true,
            dicData: DIC.FINANCIAL_TYPE
        },
        {
            label: "入账时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};